module.exports = __webpack_public_path__ + "static/media/beep.69766767.mp3";